module.exports = __webpack_public_path__ + "img/arrow.45ce5618.svg";